import React, { Fragment, useEffect, useState } from 'react';
import RightSidebar from 'components/right-sidebar';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import BottomNavigation from 'components/bottom-navigation';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { SuccessModal } from 'components/base/success-modal';
import PageHeaderText from 'components/base/page-header-text';
import { formatTimeToApiFormat } from 'utils/functions';
import useNewShopContext from 'contexts/create-shop.context';
import { getBrandDetailsNav } from './utils';

const CreateShopContent = () => {
  const { setRightSection } = useDashboardContext();
  const { createShopForm, disabled } = useNewShopContext();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const [showSuccess, setShowSuccess] = useState(false);
  const brandDetailsNav = getBrandDetailsNav(location.search);
  const shopId = searchParams.get('brand_id');

  useEffect(() => {
    setRightSection(<RightSidebar list={brandDetailsNav} />);
    return () => {
      setRightSection(null);
    };
  }, []);

  const workingHours = createShopForm?.brand_working_hours?.map((item: any) => {
    return {
      name: item.name.toLowerCase(),
      opening_time: formatTimeToApiFormat(item.opening_time),
      closing_time: formatTimeToApiFormat(item.closing_time),
      active: item.active
    };
  });

  const {
    name,
    description,
    short_text,
    logo,
    images,
    brand_business_metadatas,
    brand_keywords,
    brand_descriptive_metadatas,
    brandStatustext,
    phone,
    email,
    address,
    shopStatus,
    polygon,
    platform_fee,
    platform_fee_cap,
    service_fee,
    service_fee_cap,
    live,
    shop_polygons
  } = createShopForm;
  const payload = {
    opening_hours: workingHours?.map((data: any) => ({
      ...data,
      day: data.name,
      open_time: data.opening_time,
      close_time: data.closing_time
    })),
    name: name,
    tagline: short_text,
    phone_numbers: [phone],
    email: email,
    address: address,
    description,
    ...(logo?.trim() !== '' && { logo }),
    ...(images.length && { images: [...images] }),
    ...(brand_business_metadatas.length && { business_meta: brand_business_metadatas }),
    ...(brand_descriptive_metadatas.length && { descriptive_meta: brand_descriptive_metadatas }),
    ...(brand_keywords.length && { keyword_meta: brand_keywords }),
    shop_info: shopStatus.map((status) => ({
      name: status,
      active: true,
      note: status === 'coming_soon' ? brandStatustext : null
    })),
    polygon_ids: polygon,
    status: live,
    platform_fee: platform_fee,
    platform_fee_cap: platform_fee_cap,
    service_fee: service_fee,
    shop_polygons: shop_polygons,
    service_fee_cap: service_fee_cap
  };

  const handleConfirmForm = async () => {
    setLoading(true);

    try {
      await apiService.post('shops', {
        data: payload
      });

      setShowSuccess(true);
    } catch {
      toast(
        <ToastMessage
          type='error'
          message={`There was a problem ${shopId ? 'editing' : 'creating'} shop `}
        />
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <PageHeaderText title='Create new shop' description='Ensure you provide correct details' />
      <Outlet />
      <BottomNavigation
        loading={loading}
        list={brandDetailsNav}
        onConfirm={handleConfirmForm}
        disabled={disabled}
      />
      <SuccessModal onClose={() => setShowSuccess(false)} show={showSuccess}>
        <div>
          <p> Shop Created Successfully</p>
        </div>
      </SuccessModal>
    </Fragment>
  );
};

export default CreateShopContent;
